import {Storage} from "@/services/Storage";
import axios from "axios";
import store from "@/store";
import {responses} from "@/utils/responses";
import { setUsageUser, trackEvent } from "@/services/UsageTracker";

export default {
    name: 'user',
    state: {
        admin: '',
        currentUser: {
            Type: "",
            Username: "",
            id: "",
            Surname: "",
            Name: "",
            Password: ""
        },
        securities : [],
        users: [],
        allUsers: [],
    },
    getters: {
        getCurrentUser: (state) => state.currentUser,
        getAllUsers: (state) => state.allUsers,
        getUsers: (state) => state.users,
        getAdminUser: (state) => state.admin,

        countNonLytSoftUsers : async (state) => {
            state.users = await Storage.getAllUsers();
            return state.users.filter(user=>user.Username !== 'Admin').length;
        },

        getUserByID: (state) => async (id) => {
            state.users = await Storage.getAllUsers();
            return state.users.find(u => u.id === id);
        },
        getSecurities: (state) => state.securities,
    },
    mutations: {
        setAdminUser: async (state, data) => {
            if (!data) data = await Storage.getAdminUser();
            state.currentUser = data;
        },
        setCurrentUser: async (state, data) => {
            state.currentUser = data;
        },
        setAllSecurities: async (state, data) => {
            if (!data) data = await Storage.getAllSecurities();
            state.securities = data;
        },
        setAllUsers: async (state, data) => {
            if (!data) data = await Storage.getAllUsers();
            state.users = data
        },
    },
    actions: {
        async recordlogin(context , username) {
            trackEvent('auth', 'login', { userId: username });
            setUsageUser(username);
            let device = await Storage.getDeviceSettings();
            device = device.PC;
            let store = await Storage.getDefaultStore();
            if (!store) return;
            const payload = {
                username,
                platform: 'Kazang',
                pc: device,
            }
            return axios.post(serverApi + `supervisorOverrides/${store.StoreDB}/recordLogin`,payload)
        },

        async recordLogout(context , username) {
            let device = await Storage.getDeviceSettings();
            device = device?.PC;
            let store = await Storage.getDefaultStore();
            if (!store) return;
            const payload = {
                username: username,
                platform: 'Kazang',
                pc: device,
            }
            return axios.post(serverApi + `supervisorOverrides/${store.StoreDB}/recordLogout`,payload)
        },

        getAllUsers: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            if (!store) return;
            return axios.get(franchiseTomcatApi + `employee/${store.StoreDB}/getAll`)
                .then(({data}) => {
                    context.commit('setAllUsers', data.filter(user => !user.archived));
                    return data;
                }).catch((err) => errorHandler.tomcatError(err))
        },

        posLogin: async (context, data) => {
            let store = await Storage.getDefaultStore();
            if (!store || !store.StoreDB) {
                return { isValid: false, username: null };
            }
            const trimmed = String(data || '').trim();
            if (!trimmed) {
                return { isValid: false, username: null };
            }
            const { data: resp } = await axios.post(
                franchiseTomcatApi + `posAuth/${store.StoreDB}/login`,
                { password: trimmed }
            );
            if (!resp || !resp.success) {
                return { isValid: false, username: null };
            }
            const currentUser = context.getters.getUsers.find(
                u => u.id === resp.empId
                || (u.Username && resp.username
                    && u.Username.toLowerCase() === resp.username.toLowerCase())
            );
            if (currentUser) {
                context.commit('setCurrentUser', currentUser);
                context.dispatch('checkSmartInvoicing');
                context.dispatch('getAllStock');
            }
            return { isValid: true, username: resp.username };
        },

        // posLogin: async (context, data) => {
        //     let currentUser = context.getters.getUsers.find(user => user.Password.toLowerCase() === data.toLowerCase());
        //     if (currentUser) {
        //         await Storage.setCurrentUser(currentUser);
        //         context.commit(`setCurrentUser`, currentUser);
        //         return true
        //     }
        //     return false
        // },

        async editEmployee(context, payload) {
            let store = await Storage.getDefaultStore();
            return axios.put(franchiseTomcatApi + `employee/${store.StoreDB}/${payload.id}`, payload)
                .then(() => context.dispatch(`getAllUsers`))
                .catch((err) => {
                    if (err && err.response && err.response.status === 409) {
                        throw err;
                    }
                    return errorHandler.tomcatError(err);
                })
        },

        createEmployee : async (context, payload) => {
            let store = await Storage.getDefaultStore();
            return axios.post(franchiseTomcatApi + `employee/${store.StoreDB}`, payload)
                .then(() => context.dispatch('getAllUsers'))
                .catch((err) => {
                    if (err && err.response && err.response.status === 409) {
                        throw err;
                    }
                    return errorHandler.tomcatError(err);
                })
        },

        forceCashUp: async () => {
            let store = await Storage.getDefaultStore();
            let currentUser = await Storage.getCurrentUser()
            return axios.get(franchiseTomcatApi + `cashup/${store.StoreDB}/forceCashup?user=` + currentUser.Username+'&pc='+localStorage.getItem('_capuid'))
                .then(({data}) => data)
                .catch((err) => errorHandler.tomcatError(err))
        },

        async generateStoreOTP() {
            let store = await Storage.getDefaultStore();
            return axios.post(franchiseTomcatApi+`stores/${store.StoreDB}/generateOTP`)
                .then(({data}) => data)
                .catch((err) => errorHandler.tomcatError(err))
        },

        validateSecurityPermission: async (context, security) => {
            let securities = await Storage.getAllSecurities();
            let user = await Storage.getCurrentUser();
            let store = await Storage.getDefaultStore();
            let userType = user.Type;
            let group = securities.find(sec => sec.GroupName.toLowerCase() === userType.toLowerCase());
            if (!group) {
                await responses.showWarning(`No security group found`)
                return false;
            }
            if (!group[security]) {
                return Swal.fire({
                    title: `User not Allowed to ${security}`,
                    icon : "warning",
                    text : `Input supervisor password \n To Allow ${user.Username} to ${security}`,
                    input: "password",
                    showCloseButton : true,
                    showCancelButton: true,
                    confirmButtonText: "Authorize",
                    showLoaderOnConfirm : false,
                    preConfirm: async (password) => {
                        let storeObj = await Storage.getDefaultStore();
                        const trimmed = String(password || '').trim();
                        if (!trimmed) {
                            Swal.showValidationMessage('Incorrect password');
                            return false;
                        }
                        const { data: resp } = await axios.post(
                            backOfficeTomcatApi + `empAuth/${storeObj.StoreDB}/login`,
                            { password: trimmed }
                        );
                        if (!resp || !resp.success) {
                            if (resp && resp.requires2FA) {
                                Swal.showValidationMessage('Supervisor requires 2FA — not yet supported on mobile');
                                return false;
                            }
                            Swal.showValidationMessage('Incorrect password');
                            return false;
                        }
                        let supervisorType = resp.type;
                        let supervisorGroup = securities.find(sec => sec.GroupName.toLowerCase() === String(supervisorType || '').toLowerCase());
                        if (!supervisorGroup || !supervisorGroup[security]) {
                            Swal.showValidationMessage(`User ${resp.username} not allowed to authorise ${security}`);
                            return false;
                        }
                        return {
                            allowed: true,
                            supervisor: resp.username,
                            cashier: user.Username,
                        };
                    },
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        let value = result.value;
                        if (value.allowed === true){
                            let store = await Storage.getDefaultStore();
                            axios.post(serverApi+`supervisorOverrides/${store.StoreDB}`,{
                                Supervisor : value.supervisor,
                                Cashier : value.cashier,
                                Reason : security,
                            })
                        }
                        return value;
                    }
                    return false;
                });

            }
            if (security.toString().toLowerCase().includes(`void`)){
                return {supervisor : user.Username}
            }
            axios.post(serverApi+`supervisorOverrides/${store.StoreDB}`,{
                Supervisor : user.Username,
                Cashier : user.Username,
                Reason : security,
            })
            return true;
        },

        async getAllSecurities(context) {
            let store = await Storage.getDefaultStore();
            if (!store) return ;
            return axios.get(franchiseTomcatApi+`empsecurity/${store.StoreDB}/getAll`)
                .then(({data}) => context.commit(`setAllSecurities`, data))
                .catch((err) => errorHandler.tomcatError(err))
        },

    }
}

